
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";
import { usePolicyLines } from "@/hooks/usePolicyLines";
import { usePolicyTypes } from "@/hooks/usePolicyTypes";
import { useToast } from "@/hooks/use-toast";
import { useEffect, useState } from "react";

interface PolicyLineSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  policyType: string;
}

export const PolicyLineSelect = ({ value, onValueChange, policyType }: PolicyLineSelectProps) => {
  const { data: policyLines, isLoading: isPolicyLinesLoading } = usePolicyLines();
  const { data: policyTypes, isLoading: isPolicyTypesLoading } = usePolicyTypes();
  const [mounted, setMounted] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    setMounted(true);
    
    // Log the initial value to debug
    console.log("PolicyLineSelect: Initial value:", value);
    
    return () => setMounted(false);
  }, [value]);

  const handleValueChange = (newValue: string) => {
    console.log("PolicyLineSelect: Changed to:", newValue);
    
    const selectedLine = policyLines?.find(line => line.name === newValue);
    const filteredTypes = policyTypes?.filter(type => type.policy_line_id === selectedLine?.id) || [];
    
    console.log('PolicyLineSelect - Selection State:', {
      selectedLine,
      filteredTypes: filteredTypes.map(t => t.name),
      currentValue: newValue
    });
    
    onValueChange(newValue);
  };

  if (isPolicyLinesLoading || !mounted) {
    return (
      <div className="space-y-2">
        <Label>Policy Line</Label>
        <Skeleton className="h-14 w-full" />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="policyLine">Policy Line</Label>
      <Select onValueChange={handleValueChange} value={value || ""}>
        <SelectTrigger id="policyLine" className="w-full h-14 bg-white relative text-left">
          <SelectValue placeholder="Select Policy Line" />
        </SelectTrigger>
        <SelectContent className="bg-white border border-input shadow-lg rounded-md w-[--radix-select-trigger-width] z-50">
          {policyLines?.map((line) => (
            <SelectItem 
              key={line.id} 
              value={line.name}
              className="cursor-pointer hover:bg-accent hover:text-accent-foreground py-2 px-3"
            >
              {line.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
